function initializeSwatchToggles(rootElement = document) {
    const toggleButtons = rootElement.querySelectorAll('.swatch-toggle');
  
    toggleButtons.forEach(function(toggleButton) {
      toggleButton.addEventListener('click', function() {
        const targetFieldset = this.closest('fieldset');
  
        if (targetFieldset) {
          const swatchesToToggle = targetFieldset.querySelectorAll('.color-swatch.overflow');
          const openSpan = this.querySelector('.swatch-toggle__open');
          const closeSpan = this.querySelector('.swatch-toggle__close');
  
          swatchesToToggle.forEach(function(swatch) {
            swatch.classList.toggle('hidden');
          });
  
          openSpan.classList.toggle('hidden');
          closeSpan.classList.toggle('hidden');
        }
      });
    });
  }
  
  document.addEventListener('DOMContentLoaded', function() {
    initializeSwatchToggles();
  });
  
  let previousUrl = window.location.href;
  const urlObserver = new MutationObserver(function(mutations) {
    if (window.location.href !== previousUrl) {
      previousUrl = window.location.href;
      setTimeout(function() {
        const contentArea = document.querySelector('#main') || document.body;
        if (contentArea) {
          initializeSwatchToggles(contentArea);
        } else {
          initializeSwatchToggles();
        }
      }, 200);
    }
  });
  
  urlObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
  
  (function(history){
      var pushState = history.pushState;
      history.pushState = function(state) {
          if (typeof history.onpushstate == "function") {
              history.onpushstate({ state: state });
          }
          const pushChangeEvent = new CustomEvent('pushstatechange');
          window.dispatchEvent(pushChangeEvent);
          return pushState.apply(history, arguments);
      }
  })(window.history);
  
  window.addEventListener('pushstatechange', function() {
      setTimeout(function() {
        const contentArea = document.querySelector('#main') || document.body;
        if (contentArea) {
          initializeSwatchToggles(contentArea);
        } else {
          initializeSwatchToggles();
        }
      }, 200);
  });
  
  window.addEventListener('popstate', function() {
      setTimeout(function() {
        const contentArea = document.querySelector('#main') || document.body;
        if (contentArea) {
          initializeSwatchToggles(contentArea);
        } else {
          initializeSwatchToggles();
        }
      }, 200);
  });